module.exports = __webpack_public_path__ + "img/ClashofClansLogo.e6123cd9.png";